import SVG from './SVG'

export const AlertCircleSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="ic_alert_circle">
        <path
          fillRule="evenodd"
          d="M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z"
          className="Vector (Stroke)"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M11 16a1 1 0 011-1h.01a1 1 0 110 2H12a1 1 0 01-1-1z"
          className="Vector (Stroke)_2"
          clipRule="evenodd"
        />
        <path
          fillRule="evenodd"
          d="M12 7a1 1 0 011 1v4a1 1 0 11-2 0V8a1 1 0 011-1z"
          className="Vector (Stroke)_3"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
